import {
  CalendarClock,
  MonitorSmartphone,
  ShieldCheck,
  SlidersHorizontal,
  Store,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { DetailTabNav } from "@/components/common";

import type { ActivityDetailTabId } from "../activityDetailTabs";

interface ActivityDetailTabNavProps {
  activeTab: ActivityDetailTabId;
  onTabChange: (tab: ActivityDetailTabId) => void;
  /** Staff-only tab (platform settings + promo). */
  showStaffTab: boolean;
}

export function ActivityDetailTabNav({
  activeTab,
  onTabChange,
  showStaffTab,
}: ActivityDetailTabNavProps) {
  const { t } = useTranslation("activities");

  return (
    <DetailTabNav
      idPrefix="activity"
      ariaLabel={t("detail.tabs.ariaLabel")}
      activeTab={activeTab}
      onTabChange={onTabChange}
      tabs={[
        {
          id: "general",
          label: t("detail.tabs.general"),
          description: t("detail.tabs.generalDesc"),
          icon: <Store className="h-5 w-5" />,
        },
        {
          id: "availability",
          label: t("detail.tabs.availability"),
          description: t("detail.tabs.availabilityDesc"),
          icon: <CalendarClock className="h-5 w-5" />,
        },
        {
          id: "configuration",
          label: t("detail.tabs.configuration"),
          description: t("detail.tabs.configurationDesc"),
          icon: <SlidersHorizontal className="h-5 w-5" />,
        },
        {
          id: "preview",
          label: t("detail.tabs.preview"),
          description: t("detail.tabs.previewDesc"),
          icon: <MonitorSmartphone className="h-5 w-5" />,
        },
        ...(showStaffTab
          ? [
              {
                id: "staff" as const,
                label: t("detail.tabs.staff"),
                description: t("detail.tabs.staffDesc"),
                icon: <ShieldCheck className="h-5 w-5" />,
              },
            ]
          : []),
      ]}
    />
  );
}
